import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=c44c9760&scoped=true"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=c44c9760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44c9760",
  null
  
)

export default component.exports